export const dashboardLayout = {
  page: 'dashboard-world relative -m-4 sm:-m-6 lg:-m-10 h-[calc(100%+2rem)] sm:h-[calc(100%+3rem)] lg:h-[calc(100%+5rem)] min-h-0 overflow-hidden bg-[#061018] text-[#e8e1d2]',
  grid: 'relative grid h-full min-h-0 grid-cols-1 grid-rows-[40%_60%] lg:grid-cols-[42%_58%] lg:grid-rows-1',
  story: 'dashboard-story relative isolate overflow-hidden flex min-h-0 flex-col justify-end p-4 sm:p-5 lg:p-8',
  content: 'relative min-h-0 overflow-y-auto bg-[#061018] p-4 sm:p-4 lg:p-5 xl:p-7 flex flex-col gap-3',
};
